import RecordListItem from "./RecordListItem";

export default RecordListItem;
